import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { toast } from 'sonner';

const Hero = () => {
  const [heroData, setHeroData] = useState({
    brandName: 'Vacay With K',
    tagline1: 'CURATED TRAVEL',
    tagline2: 'UNFORGETTABLE MOMENTS',
    ctaButton: 'LEARN MORE',
    backgroundImage: 'https://images.unsplash.com/photo-1505142468610-359e7d316be0?q=80&w=2000',
    scrollToSection: 'destinations'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch hero content from public/data/hero.json
    fetch('/data/hero.json')
      .then(response => response.json())
      .then(data => {
        setHeroData(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error loading hero content:', error);
        toast.error('Failed to load hero content');
        setLoading(false);
      });
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src={heroData.backgroundImage}
          alt="Tropical Paradise"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Main Title - Script Style */}
        <h1 className="script-title text-7xl sm:text-8xl lg:text-9xl font-normal text-[#ffde59] mb-8 leading-tight tracking-wide">
          {heroData.brandName}
        </h1>

        {/* Tagline */}
        <div className="mb-12">
          <p className="text-2xl sm:text-3xl text-[#ffde59] font-light tracking-[0.3em] mb-2 brand-title">
            {heroData.tagline1}
          </p>
          <p className="text-2xl sm:text-3xl text-[#ffde59] font-light tracking-[0.3em] brand-title">
            {heroData.tagline2}
          </p>
        </div>

        {/* CTA Button */}
        <div className="flex items-center justify-center">
          <Button
            onClick={() => scrollToSection(heroData.scrollToSection)}
            size="lg"
            variant="outline"
            className="border-2 border-white/60 bg-transparent text-white hover:bg-white/10 px-12 py-6 text-lg tracking-[0.2em] backdrop-blur-sm transition-all duration-300 hover:scale-105"
          >
            {heroData.ctaButton}
          </Button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-2 bg-white rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;